import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  height: "17",
  viewBox: "0 0 30 17",
  width: "30",
  preserveAspectRatio: "xMidYMid meet"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M14.9999 13.0466L28.1798 -1.60151e-07L30 1.80174L15.4388 16.2156L15.4358 16.2126L14.9969 16.647L-0.000166017 1.80174L1.81999 0L14.9999 13.0466Z",
      "fill-rule": "evenodd",
      fill: "#FFF"
    }, null, -1)
  ]))]))
}
export default { render: render }